module.exports = __webpack_public_path__ + "static/img/banner-us.0be3b1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/banner-us.png
// module id = Db6u
// module chunks = 1